import { FC, useState } from 'react';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'react-i18next';
import { ContextMenu, RemoveModal } from '@forma/forma-ui-kit';
import SignatureModal from 'pages/MyDocuments/SignatureModal';
import SendedSignModal from 'views/ExternalFill/SendedSignModal';
import RenameModal from 'components/RenameModal';
import { hasPermission, PERMISSIONS } from 'helpers/permissions';
// import webView from 'helpers/webview';
import DocumentsItem from './DocumentsItem';

// import { ITemplateRenderData, useRenderTemplateMutation } from 'store/templates/templatesApi';

import { useAppSelector } from 'store/hooks';
import { selectUserPermissions } from 'store/user/userSlice';
import { IDocumentExternal } from 'interfaces/documents.interface';

import styles from './documents-item.module.css';

interface DocumentsItemSignProps {
  data: IDocumentExternal,
  openedId?: string | null,
  sendingId?: string | null,
  onCopyLink: (key: string, type: 'sign') => void,
  onRemove: (id: string) => void,
  onSend: (id: string, data: { login: string }) => void,
  onRename: (id: string, name: string) => void,
  onDuplicate: (id: string) => void,
}

// TODO: объединить контролы в один компонент

const DocumentsItemSign: FC<DocumentsItemSignProps> = ({
  data, onCopyLink, onDuplicate, onRemove, onSend, onRename, openedId, sendingId
}) => {
  const { t } = useTranslation();
  const userPermissions = useAppSelector(selectUserPermissions);
  const canEditDocuments = hasPermission(userPermissions ?? [], PERMISSIONS.SIGNED_EXTERNALINFILLS.EDIT);
  const canDeleteDocuments = hasPermission(userPermissions ?? [], PERMISSIONS.SIGNED_EXTERNALINFILLS.DELETE);

  const { id, name, createdAt, isReady, urlKey, signature } = data;
  const [isShowEditModal, setShowEditModal] = useState<boolean>(openedId === id);
  const [isShowRename, setShowRename] = useState<boolean>(false);
  const [isShowRemove, setShowRemove] = useState<boolean>(false);
  const [isShowSend, setShowSend] = useState<boolean>(sendingId === id);

  // const [ renderTemplate ] = useRenderTemplateMutation();

  // const handleRenderTemplate = (data: { id: string, name: string, sideValues: ITemplateRenderData['sideValues'] }) => {
  //   if (window?.navigator?.userAgent === 'forma-mobile') {
  //     webView.renderTemplate(data.id, `${name}.pdf`, { name: data.name, sideValues: data.sideValues });
  //   } else {
  //     renderTemplate(data)
  //       .unwrap()
  //       .then(url => downloadFromUrl(url, `${name}.pdf`));
  //   }
  // };

  const options = [
    // {
    //   text: t('download'),
    //   disabled: !isReady,
    //   onClick: () => handleRenderTemplate({ id: templateId, name, sideValues })
    // },
    {
      text: t('copy_link'),
      onClick: () => onCopyLink(urlKey, 'sign'),
      disabled: !!isReady || signature?.status !== 'TO_SIGN'
    },
    // {
    //   text: t('send_to_email'),
    //   onClick: () => setShowSend(true),
    //   disabled: !!isReady || signature?.status !== 'TO_SIGN'
    // },
    // {
    //   text: t('duplicate'),
    //   onClick: () => onDuplicate(id),
    //   disabled: !!isReady || signature?.status !== 'TO_SIGN'
    // },
    {
      text: t('rename'),
      onClick: () => setShowRename(true),
      disabled: !canEditDocuments,
    }, {
      text: t('delete'),
      onClick: () => setShowRemove(true),
      disabled: !canDeleteDocuments,
    }
  ];

  return (
    <DocumentsItem
      id={id}
      name={name}
      icon={`/icons/documents/${signature?.status === 'SIGNED' ? 'signed' : (signature?.status === 'REJECTED' ? 'declined' : 'to-sign')}.svg`}
      createdAt={createdAt}
      signedAt={(signature?.status === 'SIGNED') && signature.signedAt ? signature.signedAt : undefined}
      contextMenu={<>
        <ContextMenu
          offsetY={8}
          control={open => (
            <button className={classNames(styles.optionsButton, open && styles.active)}>
              <ReactSVG src="/icons/more.svg" />
            </button>
          )}
          items={options}
        />
        <RemoveModal
          open={isShowRemove}
          onClose={() => setShowRemove(false)}
          onRemove={() => onRemove(id)}
          itemName={name}
          title={t('deleting_document')}
        />
        <RenameModal
          open={isShowRename}
          onClose={() => setShowRename(false)}
          onSubmit={(name) => onRename(id, name)}
          name={name}
          title={t('rename_external_fill')}
          placeholder={t('enter_name')}
        />
        <SendedSignModal
          open={isShowSend}
          onClose={() => setShowSend(false)}
          urlKey={urlKey}
        />
        <SignatureModal
          open={isShowEditModal}
          onClose={() => setShowEditModal(false)}
          id={data.id}
          name={data.name}
        />
      </>}
      onClick={() => setShowEditModal(true)}
    />
  );
};

export default DocumentsItemSign;
